import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { CountryResponse } from "@/types/interface/region";
import { handleResponse, handleResponseError } from "@/utils/api";

export const useRegionStore = defineStore("regionStore", () => {
  const countries = ref<CountryResponse[]>([]);

  function initCountries(data: any) {
    countries.value = data?.data;
  }

  async function dispatchGetCountry(queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.region.getCountry(queryParam);
      if (status === 200 ) {
        initCountries(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    countries,
    initCountries,
    dispatchGetCountry,
  };
});